import type { TOptions } from 'i18next'

/**
 * i18next `t` function implementation for lazy i18next. Handles interpolation and
 * removes namespace.
 *
 * @param tKey
 * @param tOptions
 * @returns
 */
export function tFunctionImplementation(
  tKey: string,
  tOptions?: TOptions,
): string {
  /** Handle interpolation */
  if (tOptions && Object.values(tOptions).length) {
    Object.entries(tOptions).forEach(
      ([interpolationKey, interpolationValue]: [string, string]) => {
        const regex = new RegExp(`{{${interpolationKey}}}`, 'ig')
        if (regex.test(tKey as string)) {
          tKey = (tKey as string).replace(regex, interpolationValue)
        }
      },
    )
  }

  /** Remove namespace */
  if (tKey.includes(':') && tKey.match(/^\w+:/)) {
    tKey = tKey.split(':').slice(1).join(':')
  }

  return tKey
}
